// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddEventDialog_dialogTitle__7xLne {
  border-radius: 16px;
  color: #4d4d4d;
  font-weight: 600;
  font-size: 24px;
  width: calc(100%-50px);
  text-align: center;
}
.AddEventDialog_label__0agai {
  color: #5f6d7e;
  font-weight: 600;
  font-size: 18px;
}
.AddEventDialog_select__8kZXM,
.AddEventDialog_input__ctXmH {
  width: 100%;
  height: 55px;
  border-color: #f2f0f0;
  border-width: 2px;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 6px 5px;
  border-style: solid;
}
.AddEventDialog_select__8kZXM:focus,
.AddEventDialog_input__ctXmH:focus {
  border: 0 !important;
}
.AddEventDialog_input__ctXmH {
  min-width: 400px;
  font-weight: 500;
}

.AddEventDialog_dialogActions__NUg6d {
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 16px;
  display: flex;
}
.AddEventDialog_iconButton__voxti {
  background-color: #cb2d2d;
  color: white;
  border-radius: 4px;
  padding: 8px;
}
.AddEventDialog_cancelButton__JzAI2 {
  background-color: #ebebeb;
  color: #808080;
  margin-right: 3px;
}
.AddEventDialog_dateInput__1SkrC {
  padding: 8px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  text-align: left;
  height: 46px;
  color: #5f6d7e;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: -0.001em;
  width: 100%;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/master/calendar-utils/AddEventDialog/AddEventDialog.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".dialogTitle {\n  border-radius: 16px;\n  color: #4d4d4d;\n  font-weight: 600;\n  font-size: 24px;\n  width: calc(100%-50px);\n  text-align: center;\n}\n.label {\n  color: #5f6d7e;\n  font-weight: 600;\n  font-size: 18px;\n}\n.select,\n.input {\n  width: 100%;\n  height: 55px;\n  border-color: #f2f0f0;\n  border-width: 2px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  padding: 6px 5px;\n  border-style: solid;\n}\n.select:focus,\n.input:focus {\n  border: 0 !important;\n}\n.input {\n  min-width: 400px;\n  font-weight: 500;\n}\n\n.dialogActions {\n  padding-left: 24px;\n  padding-right: 24px;\n  margin-bottom: 16px;\n  display: flex;\n}\n.iconButton {\n  background-color: #cb2d2d;\n  color: white;\n  border-radius: 4px;\n  padding: 8px;\n}\n.cancelButton {\n  background-color: #ebebeb;\n  color: #808080;\n  margin-right: 3px;\n}\n.dateInput {\n  padding: 8px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  text-align: left;\n  height: 46px;\n  color: #5f6d7e;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.6;\n  letter-spacing: -0.001em;\n  width: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogTitle": `AddEventDialog_dialogTitle__7xLne`,
	"label": `AddEventDialog_label__0agai`,
	"select": `AddEventDialog_select__8kZXM`,
	"input": `AddEventDialog_input__ctXmH`,
	"dialogActions": `AddEventDialog_dialogActions__NUg6d`,
	"iconButton": `AddEventDialog_iconButton__voxti`,
	"cancelButton": `AddEventDialog_cancelButton__JzAI2`,
	"dateInput": `AddEventDialog_dateInput__1SkrC`
};
export default ___CSS_LOADER_EXPORT___;
